import React from '../helpers/react'
import {connect} from '../helpers/composeReducer.js';
import {tocToggleChapter, toggleTOC} from '../actions/toc.action';
import Chapter from './TOC.Chapter.js';
import Loader from './Loader.js';
import {dom} from '../helpers/react';
import classList from 'ereader-core/dist/classList.js';
import {getHookClass} from '../helpers/cssHooks.js';

const findDOMNode = dom.findDOMNode;

export const TOC = React.createClass({
    getInitialState : function(){
        return {
            fixedChapter : ''
        };
    },
    configChapter : function(id, el ,i){
        el = findDOMNode(el);
        this.offsets[id] = {
            top : el ? el.offsetTop : Infinity,
            nextChapter : this.props.chapter_stack[i+1] && this.props.chapter_stack[i+1].chapterId
        };
    },
    componentDidUpdate : function(prevProps){
        let id = this.props.opened_chapter;
        /* istanbul ignore if*/
        if (!this.offsets[id]) return;

        let current_offset = this.offsets[id].top;
        let next_id = this.offsets[id].nextChapter;
        let next_offset = next_id && this.offsets[next_id].top;

        this.current_top = current_offset;
        this.next_top = next_offset;
        // If we just opened a new chapter, set the offset
        if(this.props.opened_chapter != prevProps.opened_chapter) {
            this.refs.list.scrollTop = current_offset;
        }
    },

    render : function(){
        let classes = classList('toc', getHookClass('TOC'));

        let chapters = this.props.chapter_stack.map((chapter, i)=>{
            let props = {
                ...chapter,
                ref : (el)=>{
                    this.configChapter(chapter.chapterId, el, i);
                },
                key : chapter.chapterId,
                isFixed : this.state.fixedChapter==chapter.chapterId,
                toc_visible : this.props.visible
            };

            /* istanbul ignore else*/
            if (this.props._store) props.store = this.props._store;

            return (<Chapter
                {...props}
            />);
        });

        let body = chapters.length
            ?<ol onScroll={this.onScroll} ref="list" className='chapters'>{chapters}</ol>
            :<div className='chapters' key='loader'>{Loader('loader')}</div>;

        if (!this.props.visible) {
            classes.push('collapsed');
        }

        return (<nav id="toc-navigation" className={classes} tabIndex="-1" role="navigation">
             {body}</nav>);
    },
    onScroll : function(){
        let fixed_chapter = this.state.fixedChapter;
        let opened_chapter = this.props.opened_chapter;

        if (!opened_chapter) {
            /* istanbul ignore if*/
            if (fixed_chapter) {
                this.setState({fixedChapter : ''});
            }
            return;
        }

        let top = findDOMNode(this.refs.list).scrollTop;

        if (top >= this.current_top && top < this.next_top) {
            if (fixed_chapter != opened_chapter) {
                this.setState({
                    fixedChapter: opened_chapter
                });
            }
        } else if (fixed_chapter) {
            this.setState({
                fixedChapter : ''
            });
        }
    },
    componentWillMount : function(){
        this.offsets = {};
    }
});

export function populateProps(state){
    return {
        chapter_stack : state.toc.chapter_stack,
        opened_chapter : state.toc.opened_chapter,
        visible : state.toc.visible
    };
}

export default connect(populateProps, {
    tocToggleChapter,
    toggleTOC
})(TOC);



// WEBPACK FOOTER //
// ./src/components/TOC.js